import { fetchLoadSimpleTestResult } from "api/inspect";
import InspectHomeRecentlyRecord from "components/inspect/items/inspect.home.recently.record";
import ModalCenterLayout from "components/modal/modal.center.layout";
import ModalCenterCommonAlert from "components/pieces/modal.center.common.alert";
import { DoubleArrowIcon, RightArrowIconX16 } from "cssReset/icon";
import { InspectParams, SimpleTestResult } from "interface/interface.inspect";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Container } from "style/inspect";
import { NotLoginBox } from "style/login";
import { closeModal } from "utils/modal.util";

const InspectHome = () => {
  const [data, setData] = useState<SimpleTestResult[]>([]);
  const accessToken = localStorage.getItem("accessToken");
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState({
    isOpen: false,
    isVisible: false,
  });
  const [modalTxt, setModalTxt] = useState<string | null>(null);

  useEffect(() => {
    const authStateRaw = localStorage.getItem("authState");

    if (!authStateRaw) return; // ✅ 아예 없으면 로그인 안 된 상태
    const auth = JSON.parse(authStateRaw);

    if (!auth?.isAuthenticated) return; // ✅ 로그인 되어 있지 않으면 중단

    const loadInspectResultList = async () => {
      try {
        const params: InspectParams = {
          orderBy: "REGDT",
          orderByDir: "DESC",
          pageSize: 5,
        };
        const response = await fetchLoadSimpleTestResult(params);
        if (response.result) setData(response.result);
      } catch (error) {
        console.error(error);
      }
    };

    loadInspectResultList();
  }, []);

  const simpleTestClicked = () => {
    navigate("/inspect/simple/step");
  };

  const blockDeepTestClicked = () => {
    setModalTxt("곧 오픈 예정입니다.");
    setIsModalOpen({ isOpen: true, isVisible: true });
  };

  return (
    <Container>
      <div className="simple-measure-box" onClick={simpleTestClicked}>
        <div className="l">
          <span>층간소음 심리유형 간이 검사</span>
          <p>
            간단한 문항들로 5분만에, <br />
            나의 층간소음 민감도 유형 알아보기
          </p>
        </div>
        <div className="r">
          <DoubleArrowIcon />
        </div>
      </div>
      <div className="deep-measure-box" onClick={blockDeepTestClicked}>
        <div className="l">
          <span>층간소음 감각유형 심화 검사</span>
          <p>
            심층 질문지와 청력 검사로 더 정확하게, <br />
            나의 층간소음 민감도 진단해보기
          </p>
        </div>
        <div className="r">
          <DoubleArrowIcon />
        </div>
      </div>
      {accessToken ? (
        <div className="recently-record-box">
          <div className="t">
            <span>최근 검사 기록</span>
            <button
              onClick={() => {
                navigate("/inspect/simple/result/list");
              }}
            >
              전체 보기{" "}
              <span>
                <RightArrowIconX16 />
              </span>
            </button>
          </div>
          <div className="record">
            <InspectHomeRecentlyRecord data={data} />
          </div>
        </div>
      ) : (
        <NotLoginBox>
          <p>
            지금 솜방망이에 로그인하고, <br />
            층간소음 민감도 검사 결과를 저장해보세요! <br />
            <br />
            로그인하지 않는 경우, <br />
            검사 결과를 저장할 수 없습니다.
          </p>
          <button onClick={() => navigate("/")}>로그인 하기</button>
        </NotLoginBox>
      )}

      {isModalOpen.isOpen && (
        <ModalCenterLayout
          closedHandler={() => {
            closeModal(setIsModalOpen);
          }}
          isVisible={isModalOpen.isVisible}
        >
          <ModalCenterCommonAlert
            txt={modalTxt}
            closeModal={() => closeModal(setIsModalOpen)}
          />
        </ModalCenterLayout>
      )}
    </Container>
  );
};

export default InspectHome;
